import { api } from './api';

// Holiday master records (cross-year stamp data). The admin UI uses these
// to drive the stamp-data list and the per-group activation pickers.
export const holidaysApi = api.injectEndpoints({
  endpoints: (build) => ({
    getHolidays: build.query({
      query: () => ({ url: 'holidays', method: 'GET' }),
      transformResponse: (r) => r.data,
      providesTags: (result) =>
        result
          ? [
            ...result.map((h) => ({ type: 'Holidays', id: h.model.ID })),
            { type: 'Holidays', id: 'LIST' },
          ]
          : [{ type: 'Holidays', id: 'LIST' }],
    }),
    getHoliday: build.query({
      query: (id) => ({ url: `holiday/${id}`, method: 'GET' }),
      transformResponse: (r) => r.data,
      providesTags: (result, _error, id) => [{ type: 'Holidays', id }],
    }),
    createHoliday: build.mutation({
      query: (body) => ({ url: 'holiday', method: 'POST', body: JSON.stringify(body) }),
      invalidatesTags: [{ type: 'Holidays', id: 'LIST' }],
    }),
    updateHoliday: build.mutation({
      query: ({ id, ...body }) => ({
        url: `holiday/${id}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Holidays', id },
        { type: 'Holidays', id: 'LIST' },
      ],
    }),
    deleteHoliday: build.mutation({
      query: (id) => ({ url: `holiday/${id}`, method: 'DELETE' }),
      invalidatesTags: [{ type: 'Holidays', id: 'LIST' }],
    }),
    // Resolve concrete dates of every holiday for a given year. Used by the
    // per-year opening-hours editor to render "Karfreitag — 18.04.2025".
    resolveHolidayDates: build.query({
      query: (year) => ({ url: `holidays/resolve?year=${year}`, method: 'GET' }),
      transformResponse: (r) => r.data,
    }),
  }),
});

export const {
  useGetHolidaysQuery,
  useGetHolidayQuery,
  useCreateHolidayMutation,
  useUpdateHolidayMutation,
  useDeleteHolidayMutation,
  useResolveHolidayDatesQuery,
  useLazyResolveHolidayDatesQuery,
} = holidaysApi;
